import { BaseModel } from '@shared/base.model';
import { Organization } from '@shared/models/organization/organization.model';
import { DocumentKey } from './document-key.model';
import { DocumentTag } from './document-tag.model';

export class Document extends BaseModel<Document> {
  owner: Organization;
  bucketName: string;
  storagePrefix: string;
  documentKey: DocumentKey;
  notes: string;
  size: number;
  path: string;
  sharedBy: Organization;
  documentTags: DocumentTag[];
  formUpload: boolean;
  allowDelete: boolean;
  allowRename: boolean;
  created: Date;
  programTags: DocumentTag[]; //Shared documents only
  projectTags: DocumentTag[]; //Shared documents only
  projectGroupTags: DocumentTag[]; //Shared documents only
  projectSetPortfolioTags: DocumentTag[]; //Shared documents only
  sharedDocumentPath: string; //Shared documents only
  createUser: string;

  pathTail: string; //Transient

  constructor(documentInfo: any) {
    super();

    this.id = documentInfo.id;
    this.owner = documentInfo.owner;
    this.storagePrefix = documentInfo.storagePrefix;
    this.documentKey = documentInfo.documentKey;
    this.notes = documentInfo.notes;
    this.size = documentInfo.size;
    this.path = documentInfo.path;
    this.sharedBy = documentInfo.sharedBy;
    this.documentTags = documentInfo.documentTags;
    this.formUpload = documentInfo.formUpload;
    this.allowDelete = documentInfo.allowDelete;
    this.allowRename = documentInfo.allowRename;
    this.programTags = documentInfo.programTags;
    this.projectTags = documentInfo.projectTags;
    this.projectGroupTags = documentInfo.projectGroupTags;
    this.projectSetPortfolioTags = documentInfo.projectSetPortfolioTags;
    this.createUser = documentInfo.createUser;

    this.pathTail = this.path.split('/')[this.path.split('/').length - 1];
  }
}
